import api from './api';
import { Suggestion } from '../types/crossSystem';

export const suggestionService = {
  getForPersona: async (personaId: string, type?: string): Promise<Suggestion[]> => {
    const params: any = {};
    if (type) params.suggestion_type = type;
    const resp = await api.get(`/suggestions/persona/${personaId}`, { params });
    return resp.data;
  },

  accept: async (suggestionId: string) => {
    const resp = await api.post(`/suggestions/${suggestionId}/accept`);
    return resp.data;
  },

  dismiss: async (suggestionId: string) => {
    const resp = await api.post(`/suggestions/${suggestionId}/dismiss`);
    return resp.data;
  },

  bulkAction: async (ids: string[], action: 'accept' | 'dismiss') => {
    const resp = await api.post('/suggestions/bulk', { suggestion_ids: ids, action });
    return resp.data;
  },
};
